/**
 * Two doors, one worlds menu.
 *
 * The wordmark suffix IS the world picker (WorldSwitcher). The WORLDS item in
 * the Orb's tail is a second way into that same panel — not a trip to
 * /account and not a jump to passport.hottr.world. The picker stays in the
 * header; the Orb only asks it to open.
 *
 * A tiny listener set keeps OrbFan / OrbRail from importing WorldSwitcher
 * (they must not own worlds-switch). If no switcher is mounted, opening
 * returns false and the Orb falls back to onNavigate('passport').
 */

type WorldsFn = () => void;

const openers = new Set<WorldsFn>();
const closers = new Set<WorldsFn>();

export function subscribeWorldsMenu(opts: {
  open: WorldsFn;
  close: WorldsFn;
}): () => void {
  openers.add(opts.open);
  closers.add(opts.close);
  return () => {
    openers.delete(opts.open);
    closers.delete(opts.close);
  };
}

/** True when a WorldSwitcher heard the request. */
export function openWorldsMenu(): boolean {
  if (openers.size === 0) return false;
  for (const fn of openers) fn();
  return true;
}

export function closeWorldsMenu(): void {
  for (const fn of closers) fn();
}

/** Test seam — how many switchers are listening. */
export const worldsMenuListenerCount = (): number => openers.size;
